import React from "react";
import { inject, observer } from "mobx-react";
import CubeGraph from "../graph/CubeGraph";
import CubeDetails from "../graph/CubeDetails";
import { CubeQueryWizardButton } from "../../detail/CubeQueryWizard/CubeQueryWizardButton";
import { CubeQueryWizard } from "../../detail/CubeQueryWizard/CubeQueryWizard";
import TemplateRepresentation from "../template/TemplateRepresentation";
import Tree from "../tree/Tree";
import MemberHierarchyModal from "../tree/MemberHierarchyModal";
import { Button, InputGroup, FormControl } from "react-bootstrap";
import oneToOne from "../../../assets/1to1.png";
import oneToMany from "../../../assets/1tomany.png";
import many from "../../../assets/many.png";
import one from "../../../assets/1.png";
import "./VisContainer.scss";
import { StoreContext } from "../../../contexts/StoreContext";
import { DATAMODELS_TYPES } from "src/constants/constants-container";

const VIS_TYPES = {
  CUBE_HIERARCHY: "CubeHierarchy",
  MEMBER_HIERARCHY: "MemberHierarchy",
};

@inject(
  "http",
  "searchStore",
  "graphicalRepresentationStore",
  "detailViewStore",
  "previewStore",
  "popupStore",
  "cubeQueryWizardStore"
)
@observer
class VisContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openItems:
        this.props.type === VIS_TYPES.CUBE_HIERARCHY
          ? this.expandAllCubes(
              this.props.entityData.otherInformation.cubeHierarchyTrees
            )
          : this.props.entityData?.navigationLookupResult
              ?.navigationLookupRootItem?.object?.type === "Member"
          ? this.expandAllMembers(
              this.props.entityData.otherInformation.mainMemberHierarchyTree
            )
          : [],
      isTreeVisible: true,
      tid: "",
      modalOpenItems: [],
      showModalTree: false,
      fullSreen: false,
    };
  }

  componentWillUnmount = () => {
    this.props.cubeQueryWizardStore.resetState();
    this.handleSearchExprChange("");
  };

  componentDidMount = () => {
    if (
      this.props.entityData?.navigationLookupResult?.navigationLookupRootItem
        ?.object?.type === "Member"
    ) {
      this.handleSearchExprChange(
        this.props.entityData?.navigationLookupResult?.navigationLookupRootItem
          ?.object?.name
      );
    }
  };

  handleOpenChange = (openItems) => {
    this.setState({ openItems });
  };

  handleModalOpenChange = (modalOpenItems) => {
    this.setState({ modalOpenItems });
  };

  handleOpenModalTree = (tid) => {
    this.setState({
      showModalTree: !this.state.showModalTree,
      tid: tid,
    });
  };

  handleCloseModalTree = () => {
    this.setState({
      tid: "",
      modalOpenItems: [],
      showModalTree: !this.state.showModalTree,
    });
  };

  handleSelectionChange = (visibleItems) => {
    this.setState((prevState) => {
      return {
        visibleItems,
        activeNode: visibleItems.includes(prevState.activeNode)
          ? prevState.activeNode
          : undefined,
      };
    });
  };

  handleQueryWizardButtonClick = () => {
    this.props.cubeQueryWizardStore.toggleShowQueryWizard(
      /* state = */ true,
      /* loadCombinations = */ true
    );
  };

  handleActiveNodeChange = (id) => {
    const { visibleItems, setActiveNode, setShowDetails, setTypeSelected } =
      this.props.graphicalRepresentationStore;
    if (visibleItems.includes(id)) {
      setActiveNode(id);
      setTypeSelected("node");
      setShowDetails(true);
    }
  };
  handleActiveEdgeChange = (id) => {
    const { setActiveEdge, setShowDetails, setTypeSelected } =
      this.props.graphicalRepresentationStore;
    setActiveEdge(id);
    setTypeSelected("edge");
    setShowDetails(true);
  };

  handleSearchExprChange = (searchExpr) => {
    const { setSearchExpr } = this.props.graphicalRepresentationStore;
    setSearchExpr(searchExpr);
  };

  handleTreeToggle = () => {
    this.setState((prevState) => {
      return {
        isTreeVisible: !prevState.isTreeVisible,
      };
    });
    window.dispatchEvent(new Event("resize"));
  };
  handleFullscreenToggle = () => {
    this.setState((prevState) => {
      return {
        fullSreen: !prevState.fullSreen,
      };
    });
    window.dispatchEvent(new Event("resize"));
  };

  applyCubeFilter = (arr, searchExpr) => {
    return arr.filter((item) => {
      if (!searchExpr) return true;
      if (item["cubeName"] && item["cubeCode"]) {
        return (
          item["cubeName"].toLowerCase().includes(searchExpr.toLowerCase()) ||
          item["cubeCode"].toLowerCase().includes(searchExpr.toLowerCase())
        );
      }
      if (item["nodeName"] && item["nodeCode"]) {
        return (
          item["nodeName"].toLowerCase().includes(searchExpr.toLowerCase()) ||
          item["nodeCode"].toLowerCase().includes(searchExpr.toLowerCase())
        );
      }
      return false;
    });
  };

  showAllCubesOnMount = () => {
    const { setVisibleItems } = this.props.graphicalRepresentationStore;
    const { entityData } = this.props;
    setVisibleItems(
      this.showAllCubes(entityData.otherInformation.cubeHierarchyTrees)
    );
  };

  showAllCubes = (cubeHierarchyTrees) => {
    const { searchExpr } = this.props.graphicalRepresentationStore;
    const visibleItems = [];
    const processParent = (item, topLevelParent) => {
      const nodes = item.nodes ? item.nodes : [];
      const cubes = item.cubes
        ? this.applyCubeFilter(item.cubes, searchExpr)
        : [];
      if (item.type === "Cube" || nodes.length > 0 || cubes.length > 0) {
        visibleItems.push(
          `${item.tid}${topLevelParent ? `-${topLevelParent.tid}` : ""}`
        );
      }
      if (nodes.length > 0) {
        nodes.forEach((node) => {
          processParent(node, topLevelParent);
        });
      }
      if (cubes.length > 0) {
        cubes.forEach((cube) => {
          processParent(cube, topLevelParent);
        });
      }
    };
    cubeHierarchyTrees.forEach((item) => {
      processParent(item, item);
    });
    return visibleItems;
  };

  reset = () => {
    return [];
  };

  expandAllCubes = (cubeHierarchyTrees) => {
    const openItems = [];
    const processParent = (item, topLevelParent) => {
      const nodes = item.nodes ? item.nodes : [];
      openItems.push(
        `${item.tid}${topLevelParent ? `-${topLevelParent.tid}` : ""}`
      );
      if (nodes.length > 0) {
        nodes.forEach((node) => {
          processParent(node, topLevelParent);
        });
      }
    };
    cubeHierarchyTrees.forEach((item) => {
      processParent(item, item);
    });
    return openItems;
  };

  expandAllMembers = (memberHierarchyTrees) => {
    const openItems = [];
    const processParent = (item, topLevelParent) => {
      const nodes = item.nodes ? item.nodes : [];
      openItems.push(
        `${item.member.tid}${
          topLevelParent && topLevelParent.member
            ? `-${topLevelParent.member.tid}`
            : ""
        }`
      );
      if (nodes.length > 0) {
        nodes.forEach((node) => {
          processParent(node, topLevelParent);
        });
      }
    };
    memberHierarchyTrees?.forEach((item) => {
      processParent(item, item);
    });
    return openItems;
  };

  processCubeHierarchyTrees = (cubeHierarchyTrees, unfiltered) => {
    const { searchExpr } = this.props.graphicalRepresentationStore;
    const list = [];
    const filterChildren = (arr, refArray) => {
      return arr.filter((item) =>
        refArray.map((i) => i.tid).includes(item.tid)
      );
    };

    const processParent1 = (item, parentNodeCode = null) => {
      const obj = { ...item };
      if (parentNodeCode) {
        obj["parentNodeCode"] = parentNodeCode;
      }
      list.push(obj);
      if (item.nodes) {
        item.nodes.forEach((node) => processParent1(node));
      }
      if (item.cubes) {
        item.cubes.forEach((cube) => processParent1(cube, item.nodeCode));
      }
    };

    cubeHierarchyTrees.forEach((item) => processParent1(item));
    const filteredList = !unfiltered
      ? this.applyCubeFilter(list, searchExpr)
      : list;

    const filteredListWithParents = [...filteredList];

    const processParent2 = (item) => {
      if (item.parentNodeCode) {
        const parent = list.find((i) => i.nodeCode === item.parentNodeCode);
        if (parent) {
          const target = filteredListWithParents.find(
            (i) => i.tid === parent.tid
          );
          if (!target) {
            filteredListWithParents.push(parent);
          }
          processParent2(parent);
        }
      }
    };

    filteredList.forEach((item) => processParent2(item));
    const array = [];

    const processParent3 = (item, topLevelParent) => {
      const obj = {};
      obj.id = `${item.tid}${topLevelParent ? `-${topLevelParent.tid}` : ""}`;
      obj.tid = item.tid;
      obj.type = item.type;
      obj.name = item.type === "Cube" ? item.cubeName : item.nodeName;
      obj.code = item.type === "Cube" ? item.cubeCode : item.nodeCode;
      obj.colour = item.colour;
      obj.group = topLevelParent?.nodeName;
      if (item.nodes) {
        obj.children = [];
        filterChildren(item.nodes, filteredListWithParents).forEach((node) => {
          obj.children.push(processParent3(node, topLevelParent));
        });
      }
      if (item.cubes) {
        obj.children = [];
        filterChildren(item.cubes, filteredListWithParents).forEach((cube) => {
          obj.children.push(processParent3(cube, topLevelParent));
        });
      }
      return obj;
    };

    filterChildren(cubeHierarchyTrees, filteredListWithParents).forEach(
      (item) => {
        array.push(processParent3(item, item));
      }
    );
    return { children: [...array] };
  };

  processMemberHierarchyTrees = (memberHierarchyTrees) => {
    const { searchExpr } = this.props.graphicalRepresentationStore;
    const list = [];
    const matchesSearchExpr = (item) => {
      if (!item.member || !item.member["name"] || !item.member["code"])
        return true;
      return (
        item.member["name"].toLowerCase().includes(searchExpr.toLowerCase()) ||
        item.member["code"].toLowerCase().includes(searchExpr.toLowerCase())
      );
    };
    const filterChildren = (arr, refArray) => {
      return arr?.filter(
        (item) =>
          item.member &&
          refArray.map((i) => i.member.tid).includes(item.member.tid)
      );
    };
    const processParent1 = (item) => {
      list.push(item);
      if (item.nodes) {
        item.nodes.forEach((node) => processParent1(node));
      }
    };
    memberHierarchyTrees?.forEach((item) => processParent1(item));
    const filteredList = list.filter((item) => matchesSearchExpr(item));
    const filteredListWithParents = [...filteredList];
    const processParent2 = (item) => {
      if (item.parentMemberId) {
        const parent = list.find(
          (i) => i.member && i.member.memberId === item.parentMemberId
        );
        if (parent) {
          const target = filteredListWithParents.find(
            (i) => i.member && i.member.memberId === parent.member.memberId
          );
          if (!target) {
            filteredListWithParents.push(parent);
          }
          processParent2(parent);
        }
      }
    };
    filteredList.forEach((item) => processParent2(item));
    const array = [];
    const processParent3 = (item, topLevelParent) => {
      if (!item.member) {
        return {};
      }
      const obj = {};
      obj.id = `${item.member.tid}${
        topLevelParent && topLevelParent.member
          ? `-${topLevelParent.member.tid}`
          : ""
      }`;
      obj.tid = item.member.tid;
      obj.type = item.member.type;
      obj.name = item.member.name;
      obj.code = item.member.code;
      obj.sddMemberHierarchy = item.sddMemberHierarchy;
      if (item.nodes) {
        obj.children = [];
        filterChildren(item.nodes, filteredListWithParents)?.forEach((node) => {
          obj.children.push(processParent3(node, topLevelParent));
        });
      }
      return obj;
    };
    filterChildren(memberHierarchyTrees, filteredListWithParents)?.forEach(
      (item) => {
        array.push(processParent3(item, item));
      }
    );
    return { children: [...array] };
  };

  getCubes = (cubeHierarchyTrees) => {
    const cubes = [];
    const processParent = (item, topLevelParent) => {
      if (item.cubes) {
        const updatedCubes =
          /* this.applyCubeFilter(item.cubes, searchExpr) */ item.cubes.map(
            (cube) => {
              return {
                ...cube,
                id: `${cube.tid}-${topLevelParent.tid}`,
                group: topLevelParent.nodeName,
                colour: topLevelParent.colour,
              };
            }
          );
        cubes.push(...updatedCubes);
      }
      if (item.nodes) {
        item.nodes.forEach((node) => {
          processParent(node, topLevelParent);
        });
      }
    };
    cubeHierarchyTrees.forEach((item) => {
      processParent(item, item);
    });
    return cubes;
  };

  getRelationships = (cubeHierarchyRelationships, cubes) => {
    const relationships = [];
    const cubeIdToCubeTidMap = {};
    const cubeIdToCubeCodeMap = {};
    const cubeIdToCubeNameMap = {};
    cubes.forEach((cube) => {
      cubeIdToCubeTidMap[cube.cubeId] = cube.id;
      cubeIdToCubeCodeMap[cube.cubeId] = cube.cubeCode;
      cubeIdToCubeNameMap[cube.cubeId] = cube.cubeName;
    });
    cubeHierarchyRelationships.forEach((chr) => {
      const primaryCubeId = chr.cubeRelationship.primaryCubeId;
      const foreignCubeId = chr.cubeRelationship.foreignCubeId;
      const description = chr.cubeRelationship.description;
      const primaryCubeVariableCode =
        chr && chr.primaryVariable
          ? chr.primaryVariable.name + " (" + chr.primaryVariable.code + ")"
          : "";
      const foreignCubeVariableCode =
        chr && chr.foreignVariable
          ? chr.foreignVariable.name + " (" + chr.foreignVariable.code + ")"
          : "";
      const typeOfRelationship = chr.cubeRelationship.typeOfRelationship;
      const foreignCubeCardinality =
        chr.cubeRelationship.foreignCubeCardinality;
      const foreignCubeMandatoriness =
        chr.cubeRelationship.foreignCubeMandatoriness;
      const primaryCubeCardinality =
        chr.cubeRelationship.primaryCubeCardinality;
      const primaryCubeMandatoriness =
        chr.cubeRelationship.primaryCubeMandatoriness;
      const sourceCubeId = cubeIdToCubeTidMap[primaryCubeId];
      const destinationCubeId = cubeIdToCubeTidMap[foreignCubeId];
      const sourceCode = cubeIdToCubeCodeMap[primaryCubeId];
      const destinationCode = cubeIdToCubeCodeMap[foreignCubeId];
      const sourceName = cubeIdToCubeNameMap[primaryCubeId];
      const destinationName = cubeIdToCubeNameMap[foreignCubeId];
      const foreignCubeVariableNames = [];
      if (chr.cubeRelationshipVariablesByVariableCode) {
        Object.keys(chr.cubeRelationshipVariablesByVariableCode).forEach(
          (key) => {
            if (chr.cubeRelationshipVariablesByVariableCode[key]) {
              foreignCubeVariableNames.push(
                ...chr.cubeRelationshipVariablesByVariableCode[key].map(
                  (fcv) => fcv.name
                )
              );
            }
          }
        );
      }
      relationships.push({
        name: chr.cubeRelationship.name,
        description: description,
        from: sourceCubeId,
        to: destinationCubeId,
        type: typeOfRelationship,
        foreignCube: foreignCubeVariableCode,
        foreignCubeId: foreignCubeId,
        primaryCube: primaryCubeVariableCode,
        primaryCubeId: primaryCubeId,
        sourceCode: sourceCode,
        destinationCode: destinationCode,
        sourceName: sourceName,
        destinationName: destinationName,
        foreignCubeCardinality: foreignCubeCardinality,
        foreignCubeMandatoriness: foreignCubeMandatoriness,
        primaryCubeCardinality: primaryCubeCardinality,
        primaryCubeMandatoriness: primaryCubeMandatoriness,
        foreignCubeVariableNames: foreignCubeVariableNames.filter(
          (item, pos) => foreignCubeVariableNames.indexOf(item) === pos
        ),
      });
    });
    const filteredRelationhips = [];
    const seen = [];

    relationships.forEach((rel) => {
      const key = `${rel.primaryCubeId}-${rel.foreignCubeId}`;
      if (!seen.includes(key)) {
        const target = relationships.filter(
          (r) => `${r.primaryCubeId}-${r.foreignCubeId}` === key
        );
        // get required info from filtered relationships
        if (target && target.length) {
          rel.foreignCube = target.map((x) => x.foreignCube);
          rel.primaryCube = target.map((y) => y.primaryCube);
          rel.foreignCubeVariableNames = target
            .map((z) => z.foreignCubeVariableNames)
            .reduce((arr1, arr2) => arr1.concat(arr2), []);
        }
        filteredRelationhips.push(rel);
        seen.push(key);
      }
    });
    return filteredRelationhips;
  };
  findCubes = (data, acc) => {
    if (data.object.type === "Cube") {
      acc.push(data);
    } else {
      if (data.items)
        for (let i = 0; i < data.items.length; i += 1) {
          const currentChild = data.items[i];
          this.findCubes(currentChild, acc);
        }
    }
  };
  findItemById = (tree, nodeId) => {
    for (let node of tree) {
      if (node.object.tid.toString() === nodeId) return node;

      if (node.items) {
        let desiredNode = this.findItemById(node.items, nodeId);
        if (desiredNode) return desiredNode;
      }
    }
    return false;
  };
  findCubeToTables = (data, acc) => {
    if (data.object.type === "CubeToTable") {
      acc.push(data);
    } else {
      if (data.items)
        for (let i = 0; i < data.items.length; i += 1) {
          const currentChild = data.items[i];
          this.findCubeToTables(currentChild, acc);
        }
    }
  };
  findCubesDetails = (data, acc) => {
    if (data.object?.type === "Cube") {
      acc.push(data.object);
    } else {
      if (data.items)
        for (let i = 0; i < data.items.length; i += 1) {
          const currentChild = data.items[i];
          this.findCubesDetails(currentChild, acc);
        }
    }
  };
  static contextType = StoreContext;
  render() {
    const { type, entityData } = this.props;

    const { openItems, isTreeVisible, modalOpenItems, fullSreen } = this.state;
    const { setVisibleItems, searchExpr, visibleItems } =
      this.props.graphicalRepresentationStore;
    if (!entityData || !entityData.otherInformation) return null;
    let model = {};
    let cubes = [];
    let relationships = [];
    let searchFieldPlaceholder = "";
    let unfilteredModel = {};
    const isTemplateHierarchy =
      entityData.object.cubeHierarchyType ===
      DATAMODELS_TYPES.TEMPLATE_HIERARCHY;
    if (type === VIS_TYPES.CUBE_HIERARCHY) {
      entityData.otherInformation.cubeHierarchyTrees?.sort(
        (item) => item.orderFromCubeHierarchyNode
      );
      model = this.processCubeHierarchyTrees(
        entityData.otherInformation.cubeHierarchyTrees
      );
      unfilteredModel = this.processCubeHierarchyTrees(
        entityData.otherInformation.cubeHierarchyTrees,
        true
      );
      cubes = this.getCubes(entityData.otherInformation.cubeHierarchyTrees);
      if (!isTemplateHierarchy)
        relationships = this.getRelationships(
          entityData.otherInformation.cubeHierarchyRelationships,
          cubes
        );
      searchFieldPlaceholder = "Name or Code";
    }
    if (type === VIS_TYPES.MEMBER_HIERARCHY) {
      model = this.processMemberHierarchyTrees(
        entityData.otherInformation.memberHierarchyTree
      );
      searchFieldPlaceholder = "Member Name or Code";
    }
    const styles = {
      imageInLegend: { height: "32px", width: "32px", marginTop: "10px" },
    };
    const searchVisibleItems =
      visibleItems && visibleItems[0]
        ? visibleItems[0].substring(0, visibleItems[0]?.indexOf("-"))
        : null;
    let cubeToTableItem;
    let cubeDetails;
    if (searchVisibleItems && isTemplateHierarchy) {
      let toSearch;
      toSearch = this.findItemById(
        entityData.navigationLookupResult.navigationLookupRootItem.items,
        searchVisibleItems
      );
      let results = [];
      if (toSearch) this.findCubes(toSearch, results);
      cubeToTableItem = results;
      results = [];
      this.findCubesDetails(toSearch, results);
      cubeDetails = results;
    }

    this.props.cubeQueryWizardStore.SetHasCombinations(true);
    this.props.cubeQueryWizardStore.SetHasTemplateRepresentation(true);
    return (
      <>
        <div
          className={
            fullSreen ? "sdd-vis-container-fullscreen" : "sdd-vis-container"
          }
          style={{
            height:
              type === VIS_TYPES.CUBE_HIERARCHY
                ? fullSreen
                  ? "calc(100% - 60px)"
                  : 600
                : "auto",
            top: fullSreen
              ? this.context === this.props.detailViewStore
                ? "0px"
                : "50px"
              : null,
          }}
        >
          {type === VIS_TYPES.CUBE_HIERARCHY && !isTemplateHierarchy && (
            <div className="sdd-graph-container">
              <CubeGraph
                cubes={cubes}
                relationships={relationships}
                onNodeClick={this.handleActiveNodeChange}
                selectAll={() => this.showAllCubesOnMount()}
                onEdgeClick={this.handleActiveEdgeChange}
              />

              <CubeDetails></CubeDetails>
            </div>
          )}
          {type === VIS_TYPES.CUBE_HIERARCHY && isTemplateHierarchy && (
            <div
              className="sdd-graph-container"
              style={{
                maxWidth: "calc(100% - 60px)",
                minWidth: "800px",
              }}
            >
              <div
                style={
                  !fullSreen
                    ? {
                        position: "absolute",
                        top: -45,
                        right: 200,
                      }
                    : { position: "absolute", top: 0, right: 230 }
                }
              >
                <CubeQueryWizardButton
                  onClick={this.handleQueryWizardButtonClick}
                />
              </div>
              <TemplateRepresentation
                visibleItems={visibleItems}
                entityData={entityData}
              ></TemplateRepresentation>
              {cubeToTableItem && cubeToTableItem[0] && (
                <CubeQueryWizard
                  cubeRootItem={cubeToTableItem ? cubeToTableItem : null}
                  cubeDetails={cubeDetails ? cubeDetails : null}
                  hasCombinations={true}
                  dataSetDistributions={[]}
                  otherInformation={entityData.otherInformation}
                  isTemplateHierarchy={isTemplateHierarchy}
                />
              )}
            </div>
          )}
          {type === VIS_TYPES.CUBE_HIERARCHY ? (
            <>
              {!fullSreen &&
                (this.context !== this.props.previewStore ||
                  isTemplateHierarchy) && (
                  <Button
                    bsSize="small"
                    className="sdd-tree-toggle"
                    onClick={this.handleTreeToggle}
                  >
                    {isTreeVisible === true ? "Hide" : "Show"}
                  </Button>
                )}

              <Button
                bsSize="small"
                className="sdd-fullscreen-toggle"
                onClick={this.handleFullscreenToggle}
              >
                {fullSreen === true ? "Minimized" : "Fullscreen"}
              </Button>
            </>
          ) : null}
          {(isTreeVisible &&
            !fullSreen &&
            this.context !== this.props.previewStore) ||
          (this.context !== this.props.previewStore && !fullSreen) ||
          (isTemplateHierarchy && !fullSreen) ||
          type === VIS_TYPES.MEMBER_HIERARCHY ? (
            <div
              className={`sdd-tree-container ${
                type === VIS_TYPES.MEMBER_HIERARCHY ? "tree-only" : ""
              }`}
              style={{
                paddingTop: type === VIS_TYPES.CUBE_HIERARCHY ? 35 : 0,
              }}
            >
              <div
                className={`sdd-tree-controls-container ${
                  type === VIS_TYPES.MEMBER_HIERARCHY ? "condensed" : ""
                }`}
              >
                <Button
                  onClick={() => {
                    if (type === VIS_TYPES.CUBE_HIERARCHY) {
                      this.setState({
                        openItems: this.expandAllCubes(
                          entityData.otherInformation.cubeHierarchyTrees
                        ),
                      });
                    }
                    if (type === VIS_TYPES.MEMBER_HIERARCHY) {
                      this.setState({
                        openItems: this.expandAllMembers(
                          entityData.otherInformation.memberHierarchyTree
                        ),
                      });
                    }
                  }}
                  bsSize="small"
                >
                  Expand All
                </Button>
                <Button
                  onClick={() => {
                    this.setState({
                      openItems: this.reset(),
                    });
                  }}
                  bsSize="small"
                >
                  Collapse All
                </Button>
                {type === VIS_TYPES.CUBE_HIERARCHY && !isTemplateHierarchy && (
                  <React.Fragment>
                    <Button
                      onClick={() => {
                        setVisibleItems(
                          this.showAllCubes(
                            entityData.otherInformation.cubeHierarchyTrees
                          )
                        );
                      }}
                      bsSize="small"
                    >
                      Select All
                    </Button>
                    <Button
                      onClick={() => {
                        setVisibleItems([]);
                      }}
                      bsSize="small"
                    >
                      Unselect All
                    </Button>
                  </React.Fragment>
                )}
                <div className="sdd-tree-search-field-container">
                  <InputGroup>
                    <FormControl
                      type="text"
                      value={searchExpr}
                      onChange={(event) =>
                        this.handleSearchExprChange(event.target.value)
                      }
                      placeholder={searchFieldPlaceholder}
                      bsSize="small"
                    />
                    <InputGroup.Button>
                      <Button
                        onClick={() => {
                          this.handleSearchExprChange("");
                        }}
                        bsSize="small"
                      >
                        Clear
                      </Button>
                    </InputGroup.Button>
                  </InputGroup>
                </div>
              </div>
              <Tree
                relationships={relationships}
                model={model}
                unfilteredModel={unfilteredModel}
                onOpenChange={this.handleOpenChange}
                onSelectionChange={this.handleSelectionChange}
                onActiveNodeChange={this.handleActiveNodeChange}
                rootItem={0}
                openItems={openItems}
                withIcons={type === VIS_TYPES.CUBE_HIERARCHY}
                withSelection={type === VIS_TYPES.CUBE_HIERARCHY}
                withIconLink={type === VIS_TYPES.CUBE_HIERARCHY}
                searchExpr={searchExpr}
                openModalTree={this.handleOpenModalTree}
                currentObject={this.props.entityData.object}
                isTemplateHierarchy={isTemplateHierarchy}
              />
              {this.state.showModalTree && (
                <MemberHierarchyModal
                  tid={this.state.tid}
                  modalOpenItems={modalOpenItems}
                  isOpened={this.state.showModalTree}
                  title="Member Hierarchy Representation"
                  openModalTree={this.handleOpenModalTree}
                  onOpenChange={this.handleModalOpenChange}
                  closeModalTree={this.handleCloseModalTree}
                  processMemberHierarchyTrees={this.processMemberHierarchyTrees}
                />
              )}
            </div>
          ) : null}
        </div>
        {type === VIS_TYPES.CUBE_HIERARCHY &&
        entityData.object.cubeHierarchyType !==
          DATAMODELS_TYPES.TEMPLATE_HIERARCHY &&
        !fullSreen ? (
          <div className="vis-legend">
            <div>
              {" "}
              <h5>
                <b>Legend</b>
              </h5>
              <div style={{ marginTop: "2.5rem", marginLeft: "0.3rem" }}>
                <span style={{ fontWeight: "bold" }}>Right click + hold: </span>{" "}
                selects multiple entities{" "}
              </div>
              <div style={{ marginBottom: "2.5rem", marginLeft: "0.3rem" }}>
                <span style={{ fontWeight: "bold" }}>Left click + hold: </span>{" "}
                moves around the model{" "}
              </div>
              <div>
                Associative:
                <ul className="fa-ul">
                  <li>
                    <img
                      alt="Many, not mandatory"
                      style={styles.imageInLegend}
                      src={many}
                    ></img>
                    Many, not mandatory{" "}
                  </li>
                  <li>
                    <img
                      alt="Many, mandatory"
                      style={styles.imageInLegend}
                      src={oneToMany}
                    ></img>
                    Many, mandatory{" "}
                  </li>
                  <li>
                    <div>
                      <img
                        alt="One,
                  mandatory"
                        style={styles.imageInLegend}
                        src={oneToOne}
                      ></img>
                      One, mandatory
                    </div>
                  </li>
                  <li>
                    <div>
                      <img
                        alt="One, not mandatory"
                        style={styles.imageInLegend}
                        src={one}
                      ></img>
                      One, not mandatory
                    </div>
                  </li>
                  <li>
                    <i className="fa-li fa fa-minus fa-rotate-90"></i>{" "}
                    Unspecified cardinality
                  </li>
                </ul>
              </div>
              <div>
                Generalisation:
                <ul className="fa-ul">
                  <li>
                    <i
                      className="fa-li fa fa-play fa-rotate-180"
                      style={{ color: "#FF0000" }}
                    ></i>{" "}
                  </li>
                </ul>
              </div>
              <div style={{ marginTop: "2.5rem", marginLeft: "0.3rem" }}>
                <span style={{ fontWeight: "bold" }}>D: </span> Dimension
                (identifier), <span style={{ fontWeight: "bold" }}>O: </span>{" "}
                Observation (record information),{" "}
                <span style={{ fontWeight: "bold" }}>A: </span>Attribute
                (complementary information)
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default VisContainer;
